module.exports = __webpack_public_path__ + "img/pic-02.720fdb61.png";